import { render, staticRenderFns } from "./patient-info-module.vue?vue&type=template&id=721b719e&scoped=true&"
import script from "./patient-info-module.vue?vue&type=script&lang=js&"
export * from "./patient-info-module.vue?vue&type=script&lang=js&"
import style0 from "./patient-info-module.vue?vue&type=style&index=0&id=721b719e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721b719e",
  null
  
)

component.options.__file = "patient-info-module.vue"
export default component.exports